<template>
  <Content>
    <template #body>
      <Table
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data="fetchData"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Table from "@/components/Table";
import { getAuditHistory } from "@/api/audit";
import { enumAuditEvents } from "@/utils/filters";

const columns = [
  {
    prop: "id",
    label: "ID",
    width: 120,
  },
  {
    prop: "username",
    label: "@username",
  },
  {
    prop: "event",
    label: "Событие",
    type: "enum",
    alias: "audit_type",
  },
  {
    prop: "created_at",
    label: "Начало события",
    type: "datetime",
  },
  {
    prop: "ended_at",
    label: "Конец события",
    type: "datetime",
  },
];

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      columnsOptions: {
        sortable: "custom",
        id: "id",
        search_list: [
          {
            strong: true,
            name: "username",
            label: "Поиск по @username",
          },
          {
            strong: true,
            name: "events",
            label: "Фильтр по событиям",
            values: enumAuditEvents.map((event) => ({
              code: event.id,
              label: event.name,
            })),
          },
          {
            strong: true,
            name: "created_at_start",
            label: "Начало события - от",
            type: "datetime",
          },
          {
            strong: true,
            name: "created_at_end",
            label: "Начало события - до",
            type: "datetime",
          },
          {
            strong: true,
            name: "ended_at_start",
            label: "Конец события - от",
            type: "datetime",
          },
          {
            strong: true,
            name: "ended_at_end",
            label: "Конец события - до",
            type: "datetime",
          },
        ],
      },
      columns: columns,
      enumAuditEvents: enumAuditEvents,
    };
  },
  methods: {
    convertToUTC(dateString) {
      if (!dateString) return null;

      const date = new Date(dateString);

      if (isNaN(date.getTime())) return null;

      return date.toISOString();
    },

    async fetchData(params) {
      const { created_at_start, created_at_end, ended_at_start, ended_at_end } =
        params;

      if (created_at_start) {
        params.created_at_start = this.convertToUTC(created_at_start);
      }

      if (created_at_end) {
        params.created_at_end = this.convertToUTC(created_at_end);
      }

      if (ended_at_start) {
        params.ended_at_start = this.convertToUTC(ended_at_start);
      }

      if (ended_at_end) {
        params.ended_at_end = this.convertToUTC(ended_at_end);
      }

      const data = await getAuditHistory(params);
      return data.items;
    },
  },
};
</script>
